/**
 * English. Translated from the Dutch catalogue (`nl.ts`), which has the keys and the comments that explain them.
 */
import type {Catalogue} from './nl';

export const en: Catalogue = {
    'common.close': 'Close',
    'common.cancel': 'Cancel',
    'common.error': 'Error',
    'common.retry': 'Try again',
    'common.loading': 'Loading...',
    'common.unknownError': 'Unknown error',
    'common.busy': 'Busy… wait for the result.',
    'common.optional': '(optional)',

    'errorPage.heading': 'This page could not be shown',
    'errorPage.message':
        'Something went wrong in the terminal and the error has been passed on to the developers. Try again, or go home if it keeps happening.',
    'errorPage.loadFailed': 'The data could not be loaded',
    'errorPage.back': 'Back',
    'errorPage.home': 'Home',
    'notFound.heading': 'This page does not exist',
    'notFound.message': 'Check the address, or go home to carry on working.',

    'topNav.changeStation': 'Change station',
    'topNav.logout': 'Log out',
    'topNav.userMenu': 'User menu of {name}',
    'topNav.language': 'Language',
    'topNav.languageButton': 'Language: {language}',
    'topNav.accountLanguage': 'From my account ({language})',
    'topNav.menuArrowUp': 'Arrow up',
    'topNav.menuArrowDown': 'Arrow down',
    'topNav.menuPick': 'choose',
    'topNav.menuConfirm': 'confirm',
    'topNav.menuClose': 'close',
    'topNav.lightTheme': 'Light theme',
    'topNav.darkTheme': 'Dark theme',
    'topNav.environment': 'Environment {environment}, switch to {other}',

    'update.available': 'New version available',
    'update.reloadNow': 'Reload now',
    'update.reloadWhenIdle': 'reloads as soon as the terminal is free',
    'update.reloadIn': 'reloads automatically in {time}',
    'update.seconds': {one: '{count} s', other: '{count} s'},
    'update.minutes': {one: '{count} min', other: '{count} min'},

    'environment.title': 'Attention',
    'environment.switch': 'Switch to development',
    'environment.cancel': 'Cancel',
    'environment.warning':
        'The Shipping Terminal will connect to the test environment and shows no production data. This environment is only meant for testing new features.',

    'login.title': 'Who is logging in?',
    'login.loadingUsers': 'Loading users...',
    'pin.verifying': 'Verifying PIN...',
    'pin.prompt': 'Enter your PIN',
    'pin.promptIdle': 'Inactive: enter your PIN again',
    'pin.digit': 'Digit {index} of {total}',
    'pin.changeUser': 'Change user',
    'pin.errorInvalid': 'Wrong PIN, or too many attempts. Please try again.',
    'pin.errorFailed': 'Something went wrong while verifying the PIN: {message}',

    'terminal.loadingPrinters': 'Loading available printers...',
    'terminal.noPrinters': 'No printers found',
    'terminal.selectStation': 'Select station',
    'terminal.selectStationHint': 'Click the printer of this station, or press its number',
    'terminal.status.idle': 'Ready to scan',
    'terminal.status.notLive': 'Status not live',
    'terminal.status.mayBeOutdated': 'Status may be outdated',

    'terminal.actions': 'Actions',
    'terminal.button.printLabel': 'Print extra label',
    'terminal.button.manco': 'Problem',
    'terminal.button.deleteShipment': 'Delete shipments',
    'terminal.button.openInAdmin': 'Open in admin',

    'order.number': 'Order',
    'order.numberPlaceholder': 'Order number',
    'order.scan': 'Scan',
    'order.pickedBy': 'Picked by {user}',
    'order.pickedByUnknown': 'unknown',
    'order.created': 'Created {date}',
    'order.scanPrompt': 'Scan an order',
    'order.scanHint': 'Or type the number and press Enter',
    'scan.notRecognized': 'Scan not recognised',
    'scan.notAnOrder': '“{code}” is not an order number or container code. Scan again, or type the order number (F2).',
    'scan.tooSlow': '“{code}” came in too slowly for a scan. Scan again, or type the order number in the input (F2).',
    'scan.invalidInput': 'Type an order number of at least 6 digits, or a container code starting with B.',
    'scan.failed': 'Could not load “{code}”',
    'scan.noOrderInContainer': 'There is no open order in this container',
    'order.products': 'Pack',
    'order.shipping': 'Shipping',
    'order.noShipping': 'No shipping method',
    'order.warehouseNote': 'Warehouse note',
    'order.noWarehouseNote': 'No warehouse note',
    'order.warehouseNoteRead': 'Got it',
    'order.warnings': 'Mind when packing',
    'order.warning.hazard': 'Put on the warning labels',
    'order.warning.cans': 'This order has cans: mind how you pack them',
    'order.warning.cargo': 'Ships as cargo: pick the pallet size when printing',
    'order.hazardImageAlt': 'Warning label',

    'meta.items': 'Items',
    'meta.weight': 'Weight',
    'meta.largestSize': 'Largest size (l × w × h)',
    'meta.centimeters': '{value} cm',
    'meta.notApplicable': 'n/a',

    'address.title': 'Delivery address',

    'addressError.title': 'Correct the address',
    'addressError.hint': 'Correct the address and create the label again.',
    'addressError.createLabel': 'Create label',
    'addressError.searchGoogle': 'Search address on Google',
    'addressError.firstName': 'First name',
    'addressError.lastName': 'Last name',
    'addressError.company': 'Company',
    'addressError.street': 'Street',
    'addressError.houseNumber': 'House number',
    'addressError.addition': 'Addition',
    'addressError.zipCode': 'Postcode',
    'addressError.city': 'City',
    'addressError.email': 'Email',
    'addressError.phone': 'Phone number',
    'addressError.country': 'Country',

    'country.NL': 'Netherlands',
    'country.BE': 'Belgium',
    'country.FR': 'France',
    'country.IT': 'Italy',
    'country.DE': 'Germany',

    'manco.title': 'Report a problem',
    'manco.address': 'Address details are wrong',
    'manco.customs': 'International shipment error',
    'manco.other': 'Other',
    'manco.reported': 'Problem reported',
    'manco.failed': 'Could not report the problem: {message}',

    'packing.title': 'Attention!',
    'packing.cans': 'Mind how you pack the cans',

    'cargo.title': 'Cargo',
    'cargo.pallet': 'Pallet',
    'cargo.halfPallet': 'Half pallet',
    'cargo.miniPallet': 'Mini pallet',
    'cargo.blockPallet': 'Block pallet',
    'cargo.packages': 'Packages (stukgoed)',

    'printLabel.title': 'Print extra labels',
    'printLabel.titleAuto': 'Print labels',
    'printLabel.estimated': 'Estimated labels needed: {count}',
    'printLabel.otherAmount': 'Other amount:',
    'printLabel.count': {one: '{count} label', other: '{count} labels'},
    'printLabel.print': 'Print',

    'warningLabels.title': 'Attention!',
    'warningLabels.message': 'This order has warning labels!',
    'warningLabels.imageAlt': 'Warning label',

    'removeShipments.title': 'Delete the shipments?',
    'removeShipments.text':
        'All shipments of order {id} are deleted and cancelled at the carrier. The stock is booked back and the order goes back to paid.',

    'shipping.printWarning': 'Attention',
    'shipping.shipmentRemoved': 'Shipments deleted',
    'shipping.warningMancoReported': 'This order was reported as a manco and may not be picked completely',
    'shipping.orderFailed': 'Order {id} was not shipped',
    'shipping.stillPrinting': 'Order {id} is still printing: scan again once it is done',

    'removeShipments.failed': 'The shipments of order {id} were not deleted: {message}',
    'removeShipments.removeAnyway': 'Delete anyway',

    'outcome.unknownPrint': 'Unknown whether the labels of order {id} were printed',
    'outcome.unknownPrintHint':
        'There was no clear answer from the server. Check the printer and the order in admin (F11) before printing again.',
    'outcome.unknownRemove': 'Unknown whether the shipments of order {id} were deleted',
    'outcome.unknownRemoveHint':
        'There was no clear answer from the server. Check the order in admin (F11) before trying again.',
    'outcome.unknownManco': 'Unknown whether order {id} was reported',
    'outcome.unknownMancoHint':
        'There was no clear answer from the server. Check the order in admin (F11) before reporting it again.',
    'outcome.busy': 'Another shipping action for order {id} is still underway',
    'outcome.busyHint': 'Wait for it to finish, then check the order in admin (F11) before trying again.',
    'outcome.retryAfter': {one: 'Try again in {count} second.', other: 'Try again in {count} seconds.'},
    'outcome.reason': 'Server message: {message}',
    'outcome.printFailed': 'The labels of order {id} were created, but not printed',
    'outcome.printFailedHint':
        'Do not print again, that creates them twice. Delete the shipments first (F10), then print again.',
    'outcome.printFailedExtraHint': 'Do not print again, that creates them twice. Check the order in admin (F11).',

    'apiError.notFound': 'Not found',
    'apiError.sessionExpired': 'The session has expired. Log in again.',
    'apiError.printerNotFound': 'The printer was not found. Pick the packing station again.',
    'apiError.personalAccountRequired': 'This needs a personal account, not a shared one',
    'apiError.validationFailed': 'Invalid data: {message}',
    'apiError.internationalShipment': 'International shipment: customer service ships it',
    'apiError.shipsWithParentOrder': 'This is a backorder: it ships with the main order',
    'apiError.tooEarlyForCarrier': 'Too early for the carrier (PostNL from 7:30)',
    'apiError.orderAlreadySent': 'The order was already shipped',
    'apiError.orderNotPaid': 'The order is not paid',
    'apiError.vatNumberNotValidated': 'The customer’s VAT number has not been checked yet',
    'apiError.shippingDateInFuture': 'The order’s shipping date is in the future',
    'apiError.wrongPackingStation': 'This order cannot be shipped from this packing station',
    'apiError.paymentNotFound': 'The payment was not found at the payment provider',
    'apiError.paymentAuthorizationLost': 'The payment’s authorisation has expired',
    'apiError.customerInvoiceMissing': 'The customer’s invoice is missing',
    'apiError.cargoShippingMethod': 'This is a cargo shipment: pick a pallet size',
    'apiError.notCargoShippingMethod': 'This is not a cargo shipment',
    'apiError.orderHasShipments': 'The order already has shipments whose labels were not printed',
    'apiError.orderHasNoShipments': 'The order has no shipments',
    'apiError.recipientNameInvalid': 'The carrier refused the name',
    'apiError.postalCodeInvalid': 'The carrier refused the postcode',
    'apiError.houseNumberInvalid': 'The carrier refused the house number or its addition',
    'apiError.phoneInvalid': 'The carrier refused the phone number',
    'apiError.emailInvalid': 'The carrier refused the e-mail address',
    'apiError.addressInvalid': 'The carrier refused the street or the city',
    'apiError.servicePointInvalid': 'The pickup point is not valid',
    'apiError.labelRejected': 'The carrier refused the label: {message}',
    'apiError.adrConfigurationMissing': 'The ADR details of a product are missing',
    'apiError.shipmentFailed': 'The shipment failed: {message}',
    'apiError.labelsNotPrinted': 'The labels were created, but not printed',
    'apiError.orderBusy': 'Another action for this order is still underway',
    'apiError.paymentProviderUnavailable': 'The payment provider cannot be reached. Try again in a moment.',
};
